import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { GET_STATE_BY_COUNTRY } from "../../Graphql/queries/queryGetStateByCountry";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { MUTATION_CREATE_RUMV } from "../../Graphql/mutations/mutationCreateRUMV";
import { RoutesNames } from "../../components/utils/routes";
import { useToastError } from "../../Hooks/useToastError";
import { useToastInfo } from "../../Hooks/useToastInfo";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { validationForm } from "../../components/validations/validationForm";
import DataForm from "../../components/form/DataForm";
import IconBack from "../../components/Icons/IconBack";
import IconInfoRed from "../../components/Icons/IconInfoRed";
import ModalInformation from "../../Modals/ModalInformation";
import ModalTermsConditions from "../../Modals/ModalTermAndConditions/ModalTermsConditions";

import {
  ContainerGlobal,
  HeaderForm,
  Header,
  Text,
  Title,
  Info,
  TextBold,
  ContentForms,
  TextBack,
  BackButton,
  TextInformative,
  TopText,
  TextInformative2,
  TextRed,
  ContainerBackAndInfo,
  ContainerInformation,
  TextInformation,
  ContainerTransparent,
  ContainerForms,
  ContainerForm,
  ContainerHeaderForm,
} from "../../styles/PageStyles/LegalAndDocumental/stylesRumv";

const RUMV = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line
  const SITE_KEY = process.env.REACT_APP_SITE;
  // eslint-disable-next-line
  const TERMS_HABEAS_DATA = process.env.REACT_APP_TERMS_HABEAS_DATA;
  const [modalVisible, setModalVisible] = useState(false);
  const [modalInformation, setModalInformation] = useState(false);
  const [terms, setTerms] = useState(null);
  const [showForm, setShowForm] = useState(0);
  const [captcha, setCaptcha] = useState(null);
  const [dataForm, setDataForm] = useState({
    data: {},
    reset: null,
  });
  const [location, setLocation] = useState({
    state: "",
    city: "",
  });
  const toastSuccessful = useToastSuccessful();
  const toastInfo = useToastInfo();

  const { error, data, loading } = useQuery(GET_STATE_BY_COUNTRY);

  const [sendData, { error: errorMutation, loading: loadingMutation }] = useMutation(MUTATION_CREATE_RUMV, {
    onCompleted: (e) => {
      setTimeout(() => {
        toastSuccessful(e.createApplicationForm.message);
      }, 500);
      setTimeout(() => {
        navigate(RoutesNames.home);
      }, 1000);
    },
    onError: (err) => console.error(err),
  });

  useToastError(error || errorMutation);
  useToastLoading(loadingMutation);

  const onHandleSubmit = (values, { resetForm }) => {
    if (location.state === "" && location.city === "") {
      return toastInfo("Debe seleccionar un departamento y un municipio.");
    }
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: "submit" }).then((token) => {
        setCaptcha(token);
      });
    });
    if (
      (values.phoneNumber.length === 7 || values.phoneNumber.length === 10) &&
      (values.secondaryPhoneNumber.length === 7 || values.secondaryPhoneNumber.length === 10)
    ) {
      setModalVisible(true);
      setDataForm({
        data: values,
        reset: resetForm,
      });
    } else {
      return toastInfo("Los números de teléfono deben tener 7 o 10 números.");
    }
  };

  const onHandleShow = (form) => {
    setShowForm(form);
  };

  const checkHelp = () => {
    if (showForm === 1) return "VIRTUAL";
    if (showForm === 2) return "FACE_TO_FACE";
  };

  const onHandleAccept = (info) => {
    setModalVisible(false);
    sendData({
      variables: {
        firstName: info.data.name,
        lastName: info.data.lastName,
        phoneNumber: info.data.phoneNumber,
        secondaryPhoneNumber: info.data.secondaryPhoneNumber,
        optionalPhoneNumber: info.data.whatsAppPhoneNumber || null,
        stateId: parseInt(location.state),
        citiesId: location.city,
        termsAndConditionsAcceptedId: terms,
        email: info.data.email,
        step: "RUMV_REGISTRY",
        neighborhood: info.data.neighborhood || undefined,
        rumvNumber: "",
        helpType: checkHelp(),
        token: captcha,
      },
    });
    info.reset();
  };

  if (loading) return <LoadingScreen />;
  const states = data?.getStateByCountry.data;

  return (
    <ContainerGlobal>
      <ContentForms>
        <TopText>
          Este portal pretende únicamente ayudar a gestionar los trámites, por lo que los tiempos, aceptación, negación,
          y gestión depende exclusivamente de las entidades encargadas.
        </TopText>
        <Header>
          <Title>RUMV</Title>
          <Text>
            Este proceso lo podrás realizar directamente y de forma gratuita en la página de Migración Colombia
            <a style={{ overflowWrap: "break-word" }} href="https://www.migracioncolombia.gov.co">
              {" "}
              https://www.migracioncolombia.gov.co
            </a>
            . Si necesitas ayuda GRATUITA para realizar este proceso tan importante, solicítala en una de las siguientes
            opciones que tenemos para ti.
          </Text>
        </Header>
        <ContainerBackAndInfo>
          <BackButton onClick={() => navigate(-1)}>
            <IconBack color="#000" width={20} height={20} />
            <TextBack>Atrás</TextBack>
          </BackButton>
          <ContainerInformation onClick={() => setModalInformation(true)}>
            <IconInfoRed />
            <TextInformation>Nota importante aquí</TextInformation>
          </ContainerInformation>
          <div></div>
        </ContainerBackAndInfo>
        <ModalInformation modalOpen={modalInformation} setModalOpen={setModalInformation}>
          <TextInformative2>
            <TextRed style={{ width: "100%", textAlign: "center" }}>NOTA:</TextRed>
            <br />
            <br />
            <TextRed>1.</TextRed> A partir del 29 de mayo/2022, solo aplica para migrantes venezolanos que ingresaron a
            territorio colombiano de manera regular a través del respectivo puesto de control migratorio legalmente
            habilitado desde el 29 de mayo/2021 hasta el 24 de noviembre/2023.
            <br />
            <br />
            <TextRed>2.</TextRed> Niños, niñas y adolescentes vinculados a un proceso administrativo de restablecimiento
            de derechos (PARD) y adolescentes y jóvenes vinculados al sistema de responsabilidad penal para adolescentes
            (SRPA), como también para aquellos que se encuentran matriculados en una institución educativa en los
            niveles de educación inicial, preescolar, básica y media.
          </TextInformative2>
        </ModalInformation>
        <ContainerTransparent>
          <TextInformative>
            Te debes inscribir solo a una de las dos opciones o si no tu registro quedará invalidado y no se tendrá en
            cuenta.
          </TextInformative>
          <Info>
            <TextBold>
              *Las jornadas presenciales se realizarán siempre y cuando se inscriba suficientes personas.
              <div>
                *El equipo programador de la jornada revisará el número mínimo de personas requerido para realizarla
                según cada municipio.
              </div>
              *¡OJO se te informará telefónicamente la programación o información importante de las jornadas!.
            </TextBold>
          </Info>
          <ContainerForms>
            <ContainerHeaderForm>
              <HeaderForm
                select={showForm === 1}
                style={{ cursor: "pointer", color: "#1d1d1b", backgroundColor: "#f9b233" }}
                onClick={() => onHandleShow(1)}
              >
                Necesito ayuda virtual para realizar mi proceso del registro único de migrantes venezolanos (RUMV)
              </HeaderForm>
            </ContainerHeaderForm>
            <ContainerHeaderForm>
              <HeaderForm
                select={showForm === 2}
                style={{ cursor: "pointer", color: "#ffffff", backgroundColor: "#282d3e" }}
                onClick={() => onHandleShow(2)}
              >
                Quiero inscribirme en una jornada presencial para el proceso del registro único de migrantes venezolanos
                (RUMV)
              </HeaderForm>
            </ContainerHeaderForm>
          </ContainerForms>
          {showForm === 1 && (
            <ContainerForm>
              <DataForm
                handleSubmit={onHandleSubmit}
                dataState={states || []}
                setLocation={setLocation}
                validationSchema={validationForm}
                color="#F9B233"
              ></DataForm>
            </ContainerForm>
          )}
          {showForm === 2 && (
            <ContainerForm>
              <DataForm
                handleSubmit={onHandleSubmit}
                dataState={states || []}
                setLocation={setLocation}
                validationSchema={validationForm}
                color="#11104B"
              ></DataForm>
            </ContainerForm>
          )}
        </ContainerTransparent>
      </ContentForms>
      <ModalTermsConditions
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        press={() => onHandleAccept(dataForm)}
        setTerms={setTerms}
        idTermsAndConditions={TERMS_HABEAS_DATA}
      />
    </ContainerGlobal>
  );
};

export default RUMV;
